import React, { useState, useEffect } from 'react';
import { fetchAllPrayerTypes } from '../utilities/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Skeleton } from '../components/ui/skeleton';

function PrayerTypesDropdown({ value, onChange }) {
    const [prayertypes, setPrayerTypes] = useState([]);
    useEffect(() => {
        const fetchPrayerTypes = async () => {
            try {
                const prayerTypesData = await fetchAllPrayerTypes();
                setPrayerTypes(prayerTypesData);
            } catch (error) {
                console.error("Error fetching Prayer Types:", error);
            }
        };
        fetchPrayerTypes();

    }, []);
    return (
        <>
            {prayertypes.length === 0 ? (
                <Skeleton className="h-[34px] w-[166px] mb-2" />
            ) : (
                <Select onValueChange={onChange} value={value}>        
                        <SelectTrigger name="Prayer Types">
                    <SelectValue placeholder="All">
                        {value === "All" || !value
                            ? "All"
                            : prayertypes.find(season => parseInt(season?.id) === parseInt(value))?.attributes?.name || "All"}
                    </SelectValue>
                </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all" className='hover:bg-gold-50' selected>All</SelectItem>
                        {prayertypes.map(season => (
                            <SelectItem key={season?.id} value={season?.id}>
                                {season?.attributes?.name}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            )}
        </>
    );
}

export default PrayerTypesDropdown;